module.exports = __webpack_public_path__ + "static/carrier-pickup-and-dropoff-557f77ba008a46ec240902ec68a9e70d.png";